// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container_3QeDe","logo":"home_logo_6WOFD","background":"home_background_3j8P1","bgMiddle":"home_bgMiddle_3d_V2","spacer":"home_spacer_26ySn"};